// @flow

export const white = '#FFFFFF'

export const black = '#000000'

export const grey = {
  '50': '#FAFAFA',
  '100': '#F5F5F5',
  '200': '#EEEEEE',
  '300': '#E0E0E0',
  '400': '#BDBDBD',
  '500': '#9E9E9E',
  '600': '#757575',
  '700': '#616161',
  '800': '#424242',
  '900': '#212121',
}

export const primary = {
  contrastText: white,
  main: '#AF282F',
  light: '#E7BFC1',
  dark: '#860F12',
}

export const secondary = {
  contrastText: white,
  main: '#7d58ff',
  light: '#DCBDDB',
  dark: '#5A0C57',
}

export const text = {
  greyedOut: 'rgba(0,0,0,0.34)',
}
